import { useQuery } from '@apollo/client';
import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { GET_BASE_PLOT } from 'graphql/secure/queries/plot.queries';
import { IPlot } from 'FeatureModules/Site/types/plot.types';

const PlotTitle: FC = () => {
  const { plotId } = useParams<{
    plotId: string;
  }>();

  const { data, loading } = useQuery<{
    plot: IPlot;
  }>(GET_BASE_PLOT, { variables: { id: plotId } });

  if (loading) {
    return <span> Loading..</span>;
  }

  return <span>{data?.plot.title ? data.plot.title : 'Unnamed Plot'}</span>;
};

export default PlotTitle;
